import { lazy, Suspense, useEffect } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FloatingParticles from "@/components/FloatingParticles";
import ErrorBoundary from "@/components/ErrorBoundary";
import AITransformationPractice from "@/components/AITransformationPractice";

// Lazy-load below-the-fold sections to shrink initial JS bundle

// Старый Lovable-блок «Что такое AI-трансформация» заменён блоком из блюпринта
// «AI-трансформация на практике» (AITransformationPractice). Компонент оставлен
// в проекте на случай возврата, но из ленты убран.
// const TransformationSection = lazy(() => import("@/components/TransformationSection"));
// Блок из блюпринта «Основные направления WMT AI» — сводит четыре направления
// (обучение, продукты, разработка, усиление команды) в одну сетку 2×2. Заменил
// собой отдельные подробные секции CorporateTrainingSection / ProductsSection /
// CustomDevelopmentSection — их импорты убраны, файлы оставлены на случай возврата.
const PrimaryDirectionsSection = lazy(() => import("@/components/PrimaryDirectionsSection"));
// const ProductsSection = lazy(() => import("@/components/ProductsSection"));
// const CustomDevelopmentSection = lazy(() => import("@/components/CustomDevelopmentSection"));
// const UseCasesSection = lazy(() => import("@/components/UseCasesSection"));

const LeadMagnetSection = lazy(() => import("@/components/LeadMagnetSection"));
const EventsSection = lazy(() => import("@/components/EventsSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const Footer = lazy(() => import("@/components/Footer"));


const SectionFallback = () => <div className="min-h-[200px]" />;

const Index = () => {
  useEffect(() => {
    if (window.location.hash !== "#contact") return;

    let attempts = 0;
    let timeoutId: number | undefined;
    const scrollToContact = () => {
      const contact = document.getElementById("contact");
      if (contact) {
        contact.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
      if (attempts++ < 60) timeoutId = window.setTimeout(scrollToContact, 50);
    };

    scrollToContact();
    return () => {
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground relative">
      <Navbar />
      <div id="page-shell">
        <FloatingParticles />
        <div className="light-orb-1" />
        <div className="light-orb-2" />
        <HeroSection />
        <ErrorBoundary
          fallback={
            <div className="py-20 text-center">
              <p className="text-muted-foreground mb-4">Не удалось загрузить часть страницы.</p>
              <button
                onClick={() => window.location.reload()}
                className="px-5 py-2.5 rounded-full bg-accent text-accent-foreground font-heading"
              >
                Обновить страницу
              </button>
            </div>
          }
        >
          <Suspense fallback={<SectionFallback />}>
            <AITransformationPractice />
            <PrimaryDirectionsSection />
            <LeadMagnetSection />
            <EventsSection />
            {/* <UseCasesSection /> */}
            {/* <div className="py-3" /> */}
            <ContactSection />
            <FAQSection />
            <Footer />
          </Suspense>
        </ErrorBoundary>
      </div>

    </div>
  );
};

export default Index;
